/*
 * (c) Copyright, 2024 Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState } from 'react'
import ActionsMenuBig from '../../components/shared/ActionsMenuBig'
import ComposeNotification from './compose/ComposeNotification'

const PageMenu: React.FC = () => {
  const [isComposeModalOpen, setIsComposeModalOpen] = useState(false)

  const settings = {
    menuId: 'page',
    items: [
      {
        value: 'NOTIFICATIONS_ACTION_COMPOSE_NOTIFICATION',
        action: () => {
          console.log('Compose notification action clicked')
          setIsComposeModalOpen(true)
        }
      }
    ]
  }

  console.log('PageMenu render, isComposeModalOpen:', isComposeModalOpen)

  return (
    <div>
      <ActionsMenuBig {...settings} />
      {isComposeModalOpen && (
        <ComposeNotification
          onClose={() => {
            console.log('Closing compose notification modal')
            setIsComposeModalOpen(false)
          }}
        />
      )}
    </div>
  )
}

export default PageMenu
